import React, { PureComponent, ReactNode } from "react";
import { Popin } from "src/components";
import styled from "styled-components";

import { translate } from "../../../../../services/translation.service";
import { P } from "../../../../Semantic";

const Label = styled(P)`
  text-align: center;
`;

interface IProps {
  email: string;
  onClose: () => void;
  open: boolean;
}

export default class PopupConfirmation extends PureComponent<IProps> {
  public render(): ReactNode {
    const { email, onClose, open } = this.props;

    return (
      <Popin
        onClose={onClose}
        isOpen={open}
        title={translate("authentication.forgottenPassword")}
      >
        <Label>
          Si un compte est associé à l’adresse {email}, vous recevrez un lien
          pour réinitialiser votre mot de passe dans quelques instants. Veuillez
          cliquer sur ce lien pour réinitialiser votre mot de passe.
        </Label>
      </Popin>
    );
  }
}
